export default {
  importDialog: {
    text: {
      en: "Drag and drop the files here, or click and select",
      pt: "Arraste e solte os arquivos aqui, ou clique e selecione",
    },
    textClipboard: {
      en: "or paste from clipboard",
      pt: "ou cole do clipboard",
    },
    paste: {
      en: "Paste from clipboard",
      pt: "Colar do clipboard",
    },
  },

  labelAlert: {
    invalidFormat: {
      en: "Invalid format",
      pt: "Formato não suportado",
    },
  },
};
